export enum LayerTypesEnum {
  Vector,
  XYZ,
  WMS,
  WMTS,
}
